import { WeaverQuery, getNodeLabel } from 'Services/WeaverUtils'
import WeaverService from 'Services/WeaverService'

export default {
  memberKey: 'rdf:type'
  nameKeys: [ 'Thing_hasNameByLiteral_xsd' ]

  actionsPages: [{
    key: 'upload-excel'
    title: 'Upload Excel'
    component: 'upload_file'
    service: {
      name: 'weaver-importer-exporter',
      call: 'import',
      staticArgs: ['pallas'],
      config: { rdl: '8.0.0', iim: '5.0.0' }
    }
  }, {
    key: 'generate-turtle'
    title: 'Generate Turtle'
    component: 'generate_file'
    service: { name: 'rdf-export-service', call: 'historyToRdf', config: {rdlVersion: '8.0.0', iimVersion: '5.0.0'} }
  }]

  typeTableConfig: (type) ->
    switch type.id()
      when 'pallas:Building' # type-specific config here
        {
          title: 'Buildings'
          query: ->
            WeaverQuery()
              .hasRelationOut(
                'rdf:type',
                Weaver.Node.getFromGraph('pallas:Building', 'pallas-5')
              ).selectOut('InanimatePhysicalObject_isWholeFor_RegionInSpace')
          columns: [{
            key: 'name',
            label: 'Name',
            renderFn: (n) -> getNodeLabel(n),
            editFn: (n, val) -> n.set('Thing_hasNameByLiteral_xsd', val)
          }, {
            key: 'id',
            label: 'Id',
            renderFn: (n) -> n.id(),
            editFn: undefined
          }, {
            key: 'creator',
            label: 'Created by',
            renderFn: (n) ->
              { firstname, lastname } = WeaverService.currentProjectUsers[n.createdBy()]
              "#{ firstname } #{ lastname }"
            editFn: undefined
          }, {
            key: 'isWholeFor',
            label: 'Is Whole For',
            renderFn: (n) ->
              relations = n.relation('InanimatePhysicalObject_isWholeFor_RegionInSpace').all()
              "(#{ relations.length }) " + relations
                .map((n) -> getNodeLabel(n))
                .join(', ')
            editFn: undefined
          }]
        }
      else
        {
          title: getNodeLabel(type)
          query: ->
            WeaverQuery()
              .hasRelationOut(
                'rdf:type',
                Weaver.Node.getFromGraph(type.id(), 'pallas-5')
              )
        }
  groupings: [{
    id:    'g_1'
    label: 'Documentation'
    type: 'GROUP'
    data: {
      children: ["4", "6"]
    }
  }, {
    id:    'g_2'
    label: 'Administration'
    type: 'GROUP'
    data: {
      children: ["g_1"]
    }
  }]
  queries: []
}
